import { render, staticRenderFns } from "./BaseButtonGroup.vue?vue&type=template&id=11581e51&scoped=true&lang=pug&"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=js&"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonGroup.scss?vue&type=style&index=0&id=11581e51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11581e51",
  null
  
)

export default component.exports